import _ from 'underscore';
import { EligibleLayout } from '@bingads-webui-campaign-legacy/adextension-image/constants';

const minimumAssociationsForMultiAssetExtension = 4;

class ImageAdExtensionHelper {
  isAssociationsQualifyForMultiAsset(imageAdExtensions) {
    return _.filter(imageAdExtensions, (imageAdExtension) => {
      if (imageAdExtension.EligibleLayout === EligibleLayout.SingleAndMulti ||
        imageAdExtension.EligibleLayout === EligibleLayout.Multi) {
        return _.some(imageAdExtension.Images, (assetLink) => {
          return assetLink.Asset.SubType === 'ImageMedia133X100';
        });
      } else {
        return false;
      }
    }).length >= minimumAssociationsForMultiAssetExtension;
  }
}

const imageAdExtensionHelper = new ImageAdExtensionHelper();

export default imageAdExtensionHelper;
